import { Text } from '@chakra-ui/react';
import type { Msg } from '@halo/chat-sdk-react';
import { Fragment } from 'react';
import { MyTrans } from '@halo/ui-react';
import { MsgUserText } from '../../msg-parts';

export interface MsgGroupInviteContentProps {
  message: Msg;
}

export const MsgGroupInviteContent = memo(function MsgGroupInviteContent({
  message,
}: MsgGroupInviteContentProps) {
  const { t } = useTranslation();
  const { user_name, user_id, member = [], invite_total_count } = message.payload;
  const count = invite_total_count - member.length;

  if (member.length === 0) {
    // TODO: sdk message.payload maybe empty string, need to fix
    return null;
  }

  return (
    <MyTrans
      i18nKey={
        count > 0 ? t('chat.groupMessageInviteTextOther') : t('chat.groupMessageInviteTextOne')
      }
      components={{
        actionUser: <MsgUserText userName={user_name} userId={user_id} />,
        action: <Text as="span" color="fg.muted" />,
        members: (
          <>
            {member?.map((item: any, index: number) => (
              <Fragment key={index}>
                {index > 0 && ', '}
                <MsgUserText userName={item.user_name} userId={item.user_id} />
              </Fragment>
            ))}
          </>
        ),
        other: <Text as="span" color="fg.muted" />,
      }}
      values={{
        count,
      }}
    ></MyTrans>
  );
});
